import { render, staticRenderFns } from "./CurrentLpo__remoteImageInfo.vue?vue&type=template&id=c31f15fa&scoped=true&"
import script from "./CurrentLpo__remoteImageInfo.vue?vue&type=script&lang=js&"
export * from "./CurrentLpo__remoteImageInfo.vue?vue&type=script&lang=js&"
import style0 from "@/style/wrapper.css?vue&type=style&index=0&id=c31f15fa&scoped=true&lang=css&"
import style1 from "@/style/grid.css?vue&type=style&index=1&id=c31f15fa&scoped=true&lang=css&"
import style2 from "@/style/input.css?vue&type=style&index=2&id=c31f15fa&scoped=true&lang=css&"
import style3 from "./CurrentLpo__remoteImageInfo.vue?vue&type=style&index=3&id=c31f15fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31f15fa",
  null
  
)

export default component.exports